module.exports = __webpack_public_path__ + "media/images/shark/Fred-p-500-ff446a60722c9bfb50a2e9cd1e30133c.jpeg";